import produce from 'immer';

import {
  FETCH_FINES_SETUP_FAILURE,
  FETCH_FINES_SETUP_SUCCESS,
  UPDATE_FINES_SETUP_FAILURE,
  UPDATE_FINES_SETUP_SUCCESS,
} from '@actions/finesSetup';

const initialState: IFinesSetupStore = {
  finesSetup: null,
  error: null,
};

export default (state: IFinesSetupStore = initialState, action: any) =>
  produce(state, (draftState: IFinesSetupStore) => {
    switch (action.type) {
      case FETCH_FINES_SETUP_SUCCESS:
      case UPDATE_FINES_SETUP_SUCCESS:
        draftState.finesSetup = action.response;
        draftState.error = null;

        return;

      case FETCH_FINES_SETUP_FAILURE:
      case UPDATE_FINES_SETUP_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
